module.exports = __webpack_public_path__ + "img/widget_v06.7e242934.png";